export const ROUTE_SCROLL_MEMORY_ENABLED = true;

const STORAGE_KEY = 'route_scroll_positions_v1';
const MAX_POSITION_AGE_MS = 30 * 60 * 1000;
const MAX_STORED_ROUTES = 30;

const getRouteSignature = (location) => (
  `${location?.pathname || '/'}${location?.search || ''}${location?.hash || ''}`
);

const readPositions = () => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};

const writePositions = (positions) => {
  try {
    const entries = Object.entries(positions || {})
      .filter(([, value]) => {
        const updatedAt = Number(value?.updatedAt || 0);
        return updatedAt > 0 && Date.now() - updatedAt <= MAX_POSITION_AGE_MS;
      })
      .sort(([, left], [, right]) => Number(right.updatedAt || 0) - Number(left.updatedAt || 0))
      .slice(0, MAX_STORED_ROUTES);

    if (entries.length === 0) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(entries)));
  } catch {
    // no-op
  }
};

export const saveRouteScrollPosition = (location, scrollTop) => {
  if (!ROUTE_SCROLL_MEMORY_ENABLED || typeof sessionStorage === 'undefined') return;

  const normalizedScrollTop = Number(scrollTop);
  if (!Number.isFinite(normalizedScrollTop)) return;

  const positions = readPositions();
  positions[getRouteSignature(location)] = {
    scrollTop: Math.max(0, normalizedScrollTop),
    updatedAt: Date.now(),
  };
  writePositions(positions);
};

export const consumeRouteScrollPosition = (location, navigationType) => {
  if (
    !ROUTE_SCROLL_MEMORY_ENABLED
    || navigationType !== 'POP'
    || typeof sessionStorage === 'undefined'
  ) {
    return null;
  }

  const positions = readPositions();
  const signature = getRouteSignature(location);
  const position = positions[signature];
  if (!position) return null;

  delete positions[signature];
  writePositions(positions);

  const scrollTop = Number(position.scrollTop || 0);
  return {
    scrollTop: Number.isFinite(scrollTop) ? Math.max(0, scrollTop) : 0,
  };
};

export const clearRouteScrollPosition = (location) => {
  if (!ROUTE_SCROLL_MEMORY_ENABLED || typeof sessionStorage === 'undefined') return;

  const positions = readPositions();
  const signature = getRouteSignature(location);
  if (!Object.prototype.hasOwnProperty.call(positions, signature)) return;

  delete positions[signature];
  writePositions(positions);
};
